import { render, staticRenderFns } from "./LandingFeaturesSimpleItem.vue?vue&type=template&id=0cfc6f19"
import script from "./LandingFeaturesSimpleItem.vue?vue&type=script&lang=js"
export * from "./LandingFeaturesSimpleItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports